import React, { Component } from 'react';
import CustomInput from '../../../../Utility/Components/CustomInput';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { Tabs, Tab } from 'react-bootstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Utility from '../../../../Utility/Utility';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import Config from '../../../../Utility/Config';
import CustomButton from "../../../../Utility/Components/CustomButton"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Popover from 'react-bootstrap/Popover';

class ControlPannelModalContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }

    tabDynamicUi = (selectedTab) => {
        const { handelSelectTab, screenHandleChangeFn, screenOptionsData, tabScreenOptionsSelectedValue, gridScreenOptionsSelectedValue, tabScreenTableData, gridScreenTableData, handleChangeTextCaptions, handleChangeActiveButton, tabScreenOptionsSelectedError, gridScreenOptionsSelectedError, screenHandleChangeUniqIdentifier, uniqIdentifierOptionsData, uniqIdentifier, settingData, settingDataError } = this.props;

        let jsonParseSettingData = settingData != "" ? JSON.parse(settingData) : "";

        return (<>
            <div className="col-md-12">
                <div className='row topSpaceGap'>
                    <div className="col-md-6">
                        <div className="dropdowninnerbox">
                            <label>Screen<span style={{ color: "red" }}>*</span></label>
                            <AutosuggestComponent
                                handleOnChange={(e) => screenHandleChangeFn(e, selectedTab)}
                                options={screenOptionsData}
                                selectedValue={tabScreenOptionsSelectedValue}
                                name='screen_name'
                                isMulti={false}
                                placeholder="Select screen"
                                isSearchable={true}
                            />
                        </div>
                        <div className="col-md-12 errorClass error_div">{tabScreenOptionsSelectedError}</div>
                    </div>
                    <div className="col-md-6">
                        <div className="dropdowninnerbox">
                            <label>Uniq Identifier<span style={{ color: "red" }}>*</span></label>
                            <AutosuggestComponent
                                handleOnChange={(e) => screenHandleChangeUniqIdentifier(e, "uniq_identifier")}
                                options={uniqIdentifierOptionsData}
                                selectedValue={uniqIdentifier}
                                name='screen_name'
                                isMulti={false}
                                placeholder="Select screen"
                                isSearchable={true}
                                isDisabled={tabScreenOptionsSelectedValue == "" ? true : false}
                            />
                        </div>
                        <div className="col-md-12 errorClass error_div">{tabScreenOptionsSelectedError}</div>
                    </div>
                </div>
            </div>

            <div className="col-md-12 orgModalTable">
                <table className="screenDetailsTable">
                    <thead>
                        <tr>
                            {/* <th className='col_width'>Screen Name</th> */}
                            <th className='col_width'>Field Name</th>
                            <th className='col_width'>Default Field Caption</th>
                            <th className='col_width_input'>Modified Field Caption</th>
                            <th className='col_width_checkbox'>Active</th>
                        </tr>
                    </thead>
                    <tbody>

                        {jsonParseSettingData.length > 0 && jsonParseSettingData.map((tableData, rowIndex) => (
                            <tr key={rowIndex}>
                                {/* <td className='row_width'>{tableData.screen_name}</td> */}
                                <td className='row_width'>{tableData.field_name}</td>
                                <td className='row_width'>{tableData.field_caption}</td>
                                <td className='row_width_input'>
                                    <CustomInput
                                        // parentClassName="input_field_inner"
                                        name="text_button"
                                        type="text"
                                        value={tableData.modified_field_caption}
                                        onChange={(e) => { handleChangeTextCaptions(e, rowIndex) }}
                                        requiredStar={false}
                                        errorLabel={settingDataError.length > 0 && settingDataError[rowIndex].hasOwnProperty('message') && settingDataError[rowIndex].message != "" ? settingDataError[rowIndex].message : ""}
                                    />
                                </td>
                                <td className='row_width_checkbox'>
                                    <label className="screenCheckboxcontainer">
                                        <input type="checkbox"
                                            checked={tableData.current_status == 1 ? true : false} name="checkbox"
                                            onChange={(e) => handleChangeActiveButton(e, rowIndex)}
                                        />
                                        <span className="checkmark"></span>
                                    </label>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </>)
    }
    render() {
        const { selectedTab, handelSelectTab, screenHandleChangeFn, screenOptionsData, tabScreenOptionsSelectedValue, gridScreenOptionsSelectedValue, tabScreenTableData, gridScreenTableData, handleChangeTextCaptions, handleChangeActiveButton, tabScreenOptionsSelectedError, gridScreenOptionsSelectedError, screenHandleChangeUniqIdentifier, uniqIdentifierOptionsData, uniqIdentifier } = this.props;
        return (
            <>
                <div className="modalinnerbody">
                    <div className="col-md-12">
                        <div className='row'>
                            <Tabs
                                activeKey={selectedTab}
                                onSelect={handelSelectTab}
                                className="controlPannelTabOption"
                            >
                                <Tab eventKey="tab_captions" title="Tab Captions" key={0}></Tab>
                                <Tab eventKey="grid_field_labels" title="Grid Field Labels" key={1}></Tab>
                            </Tabs>
                        </div>
                    </div>
                    {selectedTab == "tab_captions" ?
                        this.tabDynamicUi(selectedTab)
                        :
                        this.tabDynamicUi(selectedTab)
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(ControlPannelModalContent)));